import RestrictedOperationConfirmation from './RestrictedOperationConfirmation';

export default RestrictedOperationConfirmation;
